import { useState, useCallback, useContext, useRef } from "react";
import { SuccessAlertContext } from "App";
import type { ItemSearch, ItemSearchParams, ItemSelectParams, ManagedItem } from "../types";
import productSearchApi from "../api/productSearchApi";

/**
 * 商品コード検索用hooks
 * @param companyCd String
 */
export default function useProductSearch(companyCd: string) {
  const [currentParams, setCurrentParams] = useState<ItemSearchParams>({
    company_cd: companyCd,
    limit: 100,
  });
  const [productItems, setProductItems] = useState<ItemSearch[]>([]);
  const [productLoading, setProductLoading] = useState<boolean>(false);
  const [init, setInit] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const { showAlert } = useContext(SuccessAlertContext);

  const fetchData = useCallback(
    async (params: ItemSearchParams = currentParams) => {
      setCurrentParams(params);
      setProductLoading(true);
      setError(null);

      try {
        // API呼び出し
        // const res = await productSelectApi(params);
        const res = await productSearchApi(params);
        setProductItems(res.item_list);
      } catch (err) {
        console.error(err);
        setError(err);
        showAlert("不明なエラー", "error");
        // setProductItems([]);
        // setTotal(0);
      } finally {
        setProductLoading(false);
      }
    },
    [currentParams, showAlert],
  );

  return {
    productItems,
    productLoading,
    error,
    init,
    setInit,
    setProductItems,
    fetchData,
    setProductLoading,
  };
}
